import { render } from "./ReleasePage.vue?vue&type=template&id=75d6ceeb&scoped=true"
import script from "./ReleasePage.vue?vue&type=script&lang=js"
export * from "./ReleasePage.vue?vue&type=script&lang=js"

import "./ReleasePage.vue?vue&type=style&index=0&id=75d6ceeb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d6ceeb"]])

export default __exports__